import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=845e64b6&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=ts&"
export * from "./DesktopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=845e64b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845e64b6",
  null
  
)

export default component.exports